// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-expansion-panel-content[data-v-161bb278]{display:block;padding:0 20px 20px 20px}.v-expansion-panel[data-v-161bb278]{margin:20px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
